import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { queryClient } from "@/queryClient";
import { KYCModalActionButtons } from "../KYCModalActionButtons/KYCModalActionButtons";

interface ISuccessModalProps {
  onClose: () => void;
}

export const SuccessModal: React.FC<ISuccessModalProps> = ({ onClose }) => {
  const { t } = useTranslation();

  useEffect(() => {
    void queryClient.invalidateQueries({
      queryKey: ["knowYourCustomer", "overview"],
    });
    void queryClient.invalidateQueries({
      queryKey: ["customer", "metadata"],
    });
  }, []);

  return (
    <div className="flex flex-col gap-6">
      <p className="text-gray-900 p-0 text-lg font-semibold">
        {t("KYC.modal.authentication.success.title")}
      </p>
      <p className="text-sm text-grey-dark">
        {t("KYC.modal.authentication.success.description")}
      </p>
      <KYCModalActionButtons
        onSubmit={onClose}
        submitButtonText={t("KYC.modal.buttons.close")}
        hideCancelButton
      />
    </div>
  );
};
